/*
  Linkul „Preferințe legate de modulele cookie" din subsol.

  Shopify îl generează în shop.policies cu adresa /policies/#shopifyReshowConsentBanner.
  Doua probleme pe acest magazin:
    1. /policies/ raspunde 404 (nu exista ca pagina de sine statatoare);
    2. hash-ul redeschide bannerul doar la INCARCAREA paginii si doar cat timp
       vizitatorul n-a ales inca. Dupa ce a apasat o data Acceptare sau Refuzare,
       linkul nu mai face nimic, nicaieri — exact „uneori merge, alteori nu".

  Reparatia: interceptam clicul si redeschidem pe loc BANNERUL complet, prin
  window.privacyBanner.showBanner() — acelasi lucru pe care vizitatorul il vede
  la prima vizita si la finalizarea comenzii, cu Acceptare, Refuzare si
  „Gestionați preferințele". Din el se ajunge la panoul detaliat cu un clic.
  showPreferences() (panoul detaliat direct) ramane ca rezerva, daca bannerul
  nu poate fi afisat.

  Scriptul de consimtamant se incarca asincron, asa ca daca inca nu e gata mai
  incercam ~3 secunde. Daca tot nu raspunde, ducem vizitatorul la politica de
  confidentialitate, o pagina care exista, nu la 404.
*/
(function () {
  var TINTA = 'shopifyReshowConsentBanner';
  var REZERVA = '/policies/privacy-policy';

  function esteLinkulDePreferinte(a) {
    return (a.getAttribute('href') || '').indexOf(TINTA) > -1;
  }

  function deschidePanoul() {
    var pb = window.privacyBanner;
    if (!pb) return false;

    // Intai bannerul complet, ca sa arate identic cu ce se vede la checkout.
    if (typeof pb.showBanner === 'function') {
      try {
        pb.showBanner();
        return true;
      } catch (e) {
        /* incercam rezerva de mai jos */
      }
    }

    if (typeof pb.showPreferences === 'function') {
      try {
        pb.showPreferences();
        return true;
      } catch (e) {
        return false;
      }
    }

    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!a || !esteLinkulDePreferinte(a)) return;

      e.preventDefault();

      if (deschidePanoul()) return;

      var incercari = 0;
      var cronometru = setInterval(function () {
        incercari++;
        if (deschidePanoul()) {
          clearInterval(cronometru);
          return;
        }
        if (incercari >= 30) {
          clearInterval(cronometru);
          window.location.href = REZERVA;
        }
      }, 100);
    },
    true
  );
})();
